import React, { useContext } from 'react'
import { Well } from '@pushly/aqe/lib/components'
import { getClassNames } from '../../../../_utils/classnames'
import { BetterSelect } from '../../../../components/better-select/better-select'
import PreviewSDK, { Browser } from '@pushly/cuttlefish'
import { PromptEditorContext } from '../context'
import { PromptStyle } from '@pushly/models/lib/enums/prompts/prompt-style'

export const PromptPreview = () => {
    const { loading, domain, selectedPrompt } = useContext(PromptEditorContext)

    const [browser, setBrowser] = React.useState<Browser>(Browser.CHROME)

    const style = selectedPrompt?.style ?? PromptStyle.NATIVE
    const config = selectedPrompt?.config?.serialize() ?? {}

    return (
        <Well
            className={getClassNames('prompt-preview')}
            disabled={false}
            hideFooter={true}
            mode="default"
            title="Preview"
        >
            <div className="preview-select">
                <BetterSelect
                    prefix="Browser"
                    disableSearch={true}
                    defaultValue={[browser]}
                    value={[browser]}
                    onChange={(val: Browser) => {
                        if (val && Object.values(Browser).includes(val)) {
                            setBrowser(val)
                        }
                    }}
                    options={[
                        {
                            value: Browser.CHROME,
                            label: 'Chrome',
                        },
                        {
                            value: Browser.FIREFOX,
                            label: 'FireFox',
                        },
                        {
                            value: Browser.EDGE,
                            label: 'Edge',
                        },
                        {
                            value: Browser.SAFARI,
                            label: 'Safari',
                        },
                    ]}
                />
            </div>

            <PreviewSDK.PromptPreview
                loading={loading}
                domain={domain ?? {}}
                template={{
                    title: 'Prompt Preview',
                    style: style.toLowerCase(),
                    config,
                }}
                browser={browser}
                version={'new'}
                backgroundColor={'#fff'}
                systemMode={'light'}
            />
        </Well>
    )
}
